/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const v = 'is-visible';

	const mainVisSlider = () => {
		let $mainSlider = $('.index-mainVis-slider');
		$mainSlider.owlCarousel({
			items: 1,
			loop: true,
			autoplay: true,
			autoplaySpeed: 3000,
			dots: true,
			dotsSpeed: 3000,
			thumbs: false
		});
		$('.index-mainVis-slider-pause').css('left', $('.index-mainVis .owl-dots').offset().left - 40);
		$(window).resize(() => {
			$('.index-mainVis-slider-pause').css('left', $('.index-mainVis .owl-dots').offset().left - 40);
		});
		$('.index-mainVis-slider-pause').on('click', (e) => {
			if ($(e.currentTarget).hasClass('is-pause')) {
				$mainSlider.trigger('play.owl.autoplay');
				$(e.currentTarget).removeClass('is-pause')
			} else {
				$mainSlider.trigger('stop.owl.autoplay');
				$(e.currentTarget).addClass('is-pause')
			}
		});
	};


	const worksList = () => {
		let $main = $('.index-works-main');
		$main.css('min-height', $main.height());

		$('.mod-worksList').owlCarousel({
			loop: false,
			nav: true,
			navText: [
				'<svg><use xlink:href="/okinawa/common/svg/sprite.svg#arrow_left" /></svg>',
				'<svg><use xlink:href="/okinawa/common/svg/sprite.svg#arrow_right" /></svg>'
			],
			dots: false,
			responsive: {
				320: {
					items: 2,
					margin: 10,
					dots: true,
				},
				768: {
					items: 3,
					margin: 20,
					dots: true,
				},
				1024: {
					items: 4,
					margin: 30,
					dots: false,
				}
			}
		});

		$('.mod-worksList-item .__name').matchHeight();

		$('.mod-worksList-item').on('click', (e) => {
			// メイン部分までスクロール
			let pos = $('#works-main').offset().top;
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
				pos -= 60;
			} else {
				pos -= 120;
			}
			$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');

			$main.removeClass(v);
			setTimeout(() => {
				$main.html($(e.currentTarget).html());
				setTimeout(() => {
					$main.addClass(v);
				}, 100);
			}, 300);
		});
	}

	mainVisSlider();
	// worksList();

})(window.jQuery, window.FUNCTIONS);
